<template>
  <div>
    <list-search-box v-model="form" @submit="doSearches" />
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column
          prop="projectName"
          label="项目名称"
          align="left"
          min-width="150"
          show-overflow-tooltip
        >
          <template v-slot="{ row }">
            <span class="click-span" @click="jumpToContractDetails(row)">
              {{ row.projectName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="contractNum"
          label="合同编号"
          align="left"
          min-width="130"
          show-overflow-tooltip
        />
        <el-table-column
          prop="erpOrderNum"
          label="ERP订单号"
          align="left"
          min-width="100"
          show-overflow-tooltip
        />
        <el-table-column
          prop="createTime"
          label="合同时间"
          align="left"
          min-width="180"
          show-overflow-tooltip
        />
        <el-table-column
          prop="orderTime"
          label="下单时间"
          align="left"
          min-width="180"
          show-overflow-tooltip
        />
        <el-table-column label="现销/赊销" align="left" min-width="80">
          <template v-slot="{ row }">
            <span v-if="row.salesType === 1">现销</span>
            <span v-else-if="row.salesType === 2">赊销</span>
            <span v-else-if="row.salesType === 3">LC</span>
          </template>
        </el-table-column>
        <el-table-column
          label="分配比例"
          align="right"
          header-align="left"
          min-width="70"
          show-overflow-tooltip
        >
          <template v-slot="{ row }">
            <span> {{ row.assignRatio }}% </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="salesManName"
          label="外销"
          align="left"
          min-width="130"
          show-overflow-tooltip
        />
        <el-table-column
          prop="statusValue"
          label="当前状态"
          align="left"
          min-width="90"
          show-overflow-tooltip
        />
        <!--<el-table-column prop="date" label="打印合同" width="100" align="left">-->
        <!--<template v-slot="{row}">-->
        <!--<el-button type="text">打印</el-button>-->
        <!--</template>-->
        <!--</el-table-column>-->
        <!--<el-table-column prop="date" label="签章" width="70" align="left">-->
        <!--<template v-slot="{row}">-->
        <!--<el-button type="text">签章</el-button>-->
        <!--</template>-->
        <!--</el-table-column>-->
        <el-table-column
          prop="date"
          label="操作"
          width="180"
          align="left"
        >
          <template v-slot="{ row }">
            <div>
              <el-button type="text" @click="showFile(row)">
                查看合同附件
              </el-button>
              <el-button
                v-if="row.canCeddChange"
                type="text"
                @click="goExpectedDeliveryDateChangeApply(row)"
              >
                申请客期变更
              </el-button>
              <el-button type="text" @click="returnOrExchange(row)">
                退换货申请
              </el-button>
            </div>
            <!-- <el-table-column prop="date" label="合同附件" width="120" align="left"> -->
            <!-- <template v-slot="{row}">
                <el-button type="text" @click="showFile(row)">
                  操作
                </el-button>
                <el-button type="text" @click="returnOrExchange(row)">
                  退换货申请
                </el-button>
              </template> -->
            <!-- </el-table-column> -->
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
      <contract-file-dialog ref="fileDialog" />
      <!-- 退换货申请dialog -->
      <ApplicationExchangeDialog ref="showExchangeRef" />
    </div>
  </div>
</template>
<script type="es6">
import listSearchBox from './ListSearchBox';
import contractFileDialog from './ContractFileDialog';
import { getIntOrdersContractList } from '@/API/international.js';
import ApplicationExchangeDialog from './ApplicationExchangeDialog.vue';
export default {
  data () {
    return {
      form: {
        projectName: '',
        contractNum: '',
        distributorName: '',
        salesManName: '',
        createBeginTime: '',
        createEndTime: '',
        businessApproval: 2 // 1 未审核 2 已审核
      },
      tableData: [],
      tableLoading: false,
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }

    };
  },
  components: {
    listSearchBox,
    contractFileDialog,
    ApplicationExchangeDialog
  },
  computed: {},
  methods: {
    doSearch (resolve) {
      this.tableLoading = true;
      getIntOrdersContractList({
        ...this.form,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        if (resolve) resolve();
        this.tableLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
        }
      }).catch(() => {
        if (resolve) resolve();
        this.tableLoading = false;
      });
    },
    doSearches (data, cab) {
      this.page.currentPage = 1;
      this.doSearch();
      cab(false);
    },
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.doSearch();
    },
    showFile (row) {
      this.$refs.fileDialog.showFile(row.id);
    },
    // 跳转合同详情页面路由方法
    jumpToContractDetails (params) {
      console.log(params, '66666666666666666666');
      this.$router.push({
        name: 'businessDetails',
        params: {
          contractNum: params.contractNum,
          contractType: params.contractType
        },
        query: { id: params.id, isShowInternationalService: params.civilInternational ? params.civilInternational : '0' }
      });
    },
    goExpectedDeliveryDateChangeApply (row) {
      this.$router.push({
        path: '/expectedDeliveryDateApply',
        query: {
          contractNum: row.contractNum
        }
      });
    },
    // 国际退换货申请
    returnOrExchange (row) {
      this.$refs.showExchangeRef.showExchangeDialog(row);
    }
  },
  mounted () {
    this.doSearch();
  }
};
</script>
<style scoped>
.click-span {
  color: #409EFF;
}
</style>
